export default function drivetrain (val) {
  if (!val) return
  return val.replace('Four', '4').match(/\b(\w)/g).join('')
}
